import { cx } from '@emotion/css';
import { Partition } from '@snapchat/graphene';

import type { SiteConfiguration } from '../../configTypes';
import { LoggingVendor } from '../../helpers/logging/eventListenerTypes';
import { experienceHeaderCss } from './styles/experienceHeader.styles';

export const config: SiteConfiguration = {
  domainName: 'experience.snap.com',

  theme: {
    globalNavProps: {
      showGlobalLinks: true,
      className: cx(experienceHeaderCss),
    },
  },

  headerProps: {
    className: cx(experienceHeaderCss),
  },

  trackingSettings: {
    cookieDomain: 'snap.com',
    eventListeners: [
      { vendor: LoggingVendor.BLIZZARD },
      { vendor: LoggingVendor.CONSOLE },
      { vendor: LoggingVendor.GOOGLE_CLOUD_LOGGING },
      { vendor: LoggingVendor.GOOGLE_CLOUD_MONITORING },
      { vendor: LoggingVendor.GOOGLE_CLOUD_ERROR_REPORTING },
      { vendor: LoggingVendor.MWP_HERMES },
      { vendor: LoggingVendor.GRAPHENE, partitionName: Partition.EXPERIENCE },
      {
        vendor: LoggingVendor.GOOGLE_TAG_MANAGER,
        googleAnalyticsId: 'G-KQ0NHS593H',
        googleTagManagerId: 'GTM-PB72WQ3',
      },
      {
        vendor: LoggingVendor.SENTRY,
        projectName: 'experience',
        dsn: 'https://4f860f15f13d4d88b16fba551bf00d83@sentry.sc-prod.net/232',
      },
    ],
  },
  redirects: {
    hostRedirects: {},
  },

  csp: [
    // TODO: Break up into multiple CSP entries, and move the third party ones into the CSP folder.
    {
      mediaSrc: [
        // MWP AWS Live Streams served via Cloudfront (us-east-1)
        'https://dawsl0usjozbe.cloudfront.net',
        'https://d3ndip0bu6gh7y.cloudfront.net',
        'https://d1ye9ow8r70slh.cloudfront.net',
        'https://d1hh5vpcxdyhkt.cloudfront.net',
        'https://d2q98a4sn65ac4.cloudfront.net',
        'https://d1pbenklnwbdbg.cloudfront.net',
        'https://d3tzyb7v89a3or.cloudfront.net',
        'https://d207qkqsvlnlrd.cloudfront.net',

        // MWP AWS Live Streams served via Cloudfront (us-west-2)
        'https://d19cigsb432ysf.cloudfront.net',
        'https://d2l6n6ftlv3e60.cloudfront.net',
        'https://d1wn3m890fwq8i.cloudfront.net',
        'https://d1q15k1obc4wf5.cloudfront.net',
        'https://d3mgfalmuy0upt.cloudfront.net',
        'https://dysho6w4igpp2.cloudfront.net',
        'https://d19s0are39xo3j.cloudfront.net',
        'https://d114s8gn9lncd.cloudfront.net',

        // MWP AWS VODs served via Cloudfront
        'https://d2c0et4w5flcyu.cloudfront.net',

        // AV team feeds
        'https://snap-scheduler-west1-boehnhqrh-cdn.sa.metacdn.com/',
        'https://snap-scheduler-apac1-boehnhqrh-cdn.sa.metacdn.com/',
      ],
      connectSrc: [
        // MWP AWS Live Streams served via Cloudfront (us-east-1)
        'https://dawsl0usjozbe.cloudfront.net',
        'https://d3ndip0bu6gh7y.cloudfront.net',
        'https://d1ye9ow8r70slh.cloudfront.net',
        'https://d1hh5vpcxdyhkt.cloudfront.net',
        'https://d2q98a4sn65ac4.cloudfront.net',
        'https://d1pbenklnwbdbg.cloudfront.net',
        'https://d3tzyb7v89a3or.cloudfront.net',
        'https://d207qkqsvlnlrd.cloudfront.net',

        // MWP AWS Live Streams served via Cloudfront (us-west-2)
        'https://d19cigsb432ysf.cloudfront.net',
        'https://d2l6n6ftlv3e60.cloudfront.net',
        'https://d1wn3m890fwq8i.cloudfront.net',
        'https://d1q15k1obc4wf5.cloudfront.net',
        'https://d3mgfalmuy0upt.cloudfront.net',
        'https://dysho6w4igpp2.cloudfront.net',
        'https://d19s0are39xo3j.cloudfront.net',
        'https://d114s8gn9lncd.cloudfront.net',

        // MWP AWS VODs served via Cloudfront
        'https://d2c0et4w5flcyu.cloudfront.net',

        // AV team feeds
        'https://snap-scheduler-west1-boehnhqrh-cdn.sa.metacdn.com/',
        'https://snap-scheduler-apac1-boehnhqrh-cdn.sa.metacdn.com/',

        // Bitmovin video analytics integration
        'https://analytics-ingress-global.bitmovin.com',
      ],
    },
  ],
  cacheControl: {
    noCachePaths: ['/lawenforcementsummit-usa-live'],
  },
  // Enable other locales in Staging & prepare Lilt integration, but don't use in Production until localization is complete
  localeFilter: ['en-US'],
};
